import React from 'react';

/**
 * Пропсы для компонента ConfirmDialog
 */
interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

/**
 * Компонент диалога подтверждения
 * Использует DaisyUI modal компонент
 * @param isOpen - Открыт ли диалог
 * @param title - Заголовок диалога
 * @param message - Сообщение диалога
 * @param confirmText - Текст кнопки подтверждения
 * @param cancelText - Текст кнопки отмены
 * @param onConfirm - Функция подтверждения
 * @param onCancel - Функция отмены
 * @param isLoading - Состояние загрузки
 * @returns JSX элемент
 */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg mb-4">{title}</h3>
        <p className="text-base-content/80 mb-6">{message}</p>

        <div className="modal-action">
          <button
            onClick={onCancel}
            className="btn btn-ghost"
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-error"
            disabled={isLoading}
          >
            {isLoading && (
              <span className="loading loading-spinner loading-sm mr-2"></span>
            )}
            {confirmText}
          </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onCancel}></div>
    </div>
  );
};
